export default "__VITE_ASSET__BT$2ngU___"